exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-cta[data-v-51fc5faa] {\n  border-color: white;\n  color: white;\n  font-weight: 600;\n  text-align:center;\n}\n\n", ""]);

// exports
